import type { StsIconName } from '@packages/ui/shared';

/** A message a tab of the module panel shows in place of its content. */
export type ModuleMessage = {
    /** The translation key of the text under the title. */
    description: string;
    /** The icon over the title. */
    icon: StsIconName;
    /** The widest the texts may be, in pixels, when the design narrows them below the panel's width. */
    textWidth?: number;
    /** The translation key of the title. */
    title: string;
};

/** The message of a module that reports no DTC. */
export const CLEAR_MESSAGE: ModuleMessage = {
    description: 'ssm5:module.clear.description',
    icon: 'check-circle-hollow',
    title: 'ssm5:module.clear.title',
};

/** The message of a module whose DTCs the filters all hide, the one the Status and DTCs list shows. */
export const FILTERED_OUT_MESSAGE: ModuleMessage = {
    description: 'ssm5:dtcs.filteredOut.description',
    icon: 'filter',
    title: 'ssm5:dtcs.filteredOut.title',
};

/** The message of a module that does not answer, shown on both tabs; the design narrows its texts to 274px. */
export const NOT_COMMUNICATING_MESSAGE: ModuleMessage = {
    description: 'ssm5:module.notCommunicating.description',
    icon: 'x-circle',
    textWidth: 274,
    title: 'ssm5:module.notCommunicating.title',
};
